import { render } from "./CatalogueForm.vue?vue&type=template&id=b6fa1790&scoped=true"
import script from "./CatalogueForm.vue?vue&type=script&lang=js"
export * from "./CatalogueForm.vue?vue&type=script&lang=js"

import "./CatalogueForm.vue?vue&type=style&index=0&id=b6fa1790&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6fa1790"]])

export default __exports__